var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnFilePng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 241,
    viewBox: "0 0 200 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.67 49.9902C134.202 49.9823 128.96 47.8059 125.095 43.9385C121.229 40.071 119.055 34.8283 119.05 29.3602V0.740236H26.9203C23.3856 0.738923 19.8851 1.434 16.619 2.78577C13.353 4.13753 10.3853 6.11945 7.8854 8.61841C5.38552 11.1174 3.40245 14.0843 2.04947 17.3499C0.696487 20.6154 0.000150283 24.1154 0.000150527 27.6501V189.83C-0.0116969 193.372 0.675913 196.882 2.02359 200.158C3.37126 203.434 5.3526 206.412 7.85367 208.92C10.3547 211.429 13.3264 213.419 16.5983 214.776C19.8702 216.134 23.378 216.832 26.9203 216.83H137.52C144.657 216.83 151.502 213.995 156.548 208.948C161.595 203.902 164.43 197.057 164.43 189.92V49.9902H139.67Z",
    fill: "#005FAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.43 49.9902H139.67C134.202 49.9823 128.96 47.8059 125.094 43.9385C121.229 40.071 119.055 34.8283 119.05 29.3602V0.740234L164.43 49.9902Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 171.34H58.8999C50.0302 171.34 42.8398 178.53 42.8398 187.4V224.68C42.8398 233.55 50.0302 240.74 58.8999 240.74H183.94C192.809 240.74 200 233.55 200 224.68V187.4C200 178.53 192.809 171.34 183.94 171.34Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0603 214.119V221.389H71.5303V214.119H79.0603Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1206 210.831V221.381H82.8506V191.311H94.6306C98.2006 191.311 100.921 192.191 102.791 193.971C103.737 194.898 104.477 196.016 104.961 197.25C105.446 198.484 105.664 199.806 105.601 201.131C105.628 202.878 105.197 204.602 104.351 206.131C103.476 207.625 102.178 208.825 100.621 209.581C98.7469 210.464 96.6911 210.892 94.6206 210.831H90.1206ZM98.2004 201.131C98.2004 198.504 96.7406 197.171 93.8206 197.131H90.1206V204.951H93.8206C96.7406 204.991 98.2004 203.721 98.2004 201.141V201.131Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.88 221.39H128.61L116.45 202.93V221.39H109.17V191.32H116.45L128.61 209.95V191.32H135.88V221.39Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.32 193.829C166.744 195.649 168.377 198.33 168.88 201.319H161.18C160.678 200.246 159.862 199.35 158.84 198.749C157.35 197.934 155.634 197.626 153.953 197.871C152.272 198.117 150.716 198.902 149.52 200.109C148.057 201.86 147.314 204.101 147.44 206.379C147.44 209.249 148.17 211.439 149.63 212.969C150.45 213.767 151.428 214.385 152.501 214.781C153.574 215.177 154.719 215.343 155.86 215.269C157.491 215.302 159.088 214.804 160.41 213.849C161.76 212.838 162.735 211.406 163.18 209.779H153.99V204.549H169.26V211.739C168.673 213.527 167.75 215.187 166.54 216.629C165.228 218.183 163.594 219.431 161.75 220.289C159.669 221.256 157.395 221.735 155.1 221.689C152.31 221.762 149.55 221.097 147.1 219.759C144.862 218.5 143.038 216.617 141.85 214.339C140.631 211.865 139.997 209.143 139.997 206.384C139.997 203.626 140.631 200.904 141.85 198.429C143.033 196.155 144.85 194.272 147.08 193.009C149.493 191.677 152.215 191.007 154.97 191.069C158.307 190.922 161.598 191.894 164.32 193.829Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7002 67.459H40.9502V81.209H54.7002V67.459Z",
    fill: "#005FAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.46 81.209H54.71V94.959H68.46V81.209Z",
    fill: "#005FAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.21 67.459H68.46V81.209H82.21V67.459Z",
    fill: "#005FAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.96 81.209H82.21V94.959H95.96V81.209Z",
    fill: "#005FAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.72 67.459H95.9697V81.209H109.72V67.459Z",
    fill: "#005FAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.479 81.209H109.729V94.959H123.479V81.209Z",
    fill: "#005FAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7002 94.9395H40.9502V108.689H54.7002V94.9395Z",
    fill: "#005FAD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.46 108.689H54.71V122.439H68.46V108.689Z",
    fill: "#005FAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.21 94.9395H68.46V108.689H82.21V94.9395Z",
    fill: "#005FAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.96 108.689H82.21V122.439H95.96V108.689Z",
    fill: "#005FAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.72 94.9395H95.9697V108.689H109.72V94.9395Z",
    fill: "#005FAD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.479 108.689H109.729V122.439H123.479V108.689Z",
    fill: "#005FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7002 122.551H40.9502V136.301H54.7002V122.551Z",
    fill: "#005FAD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.46 136.301H54.71V150.051H68.46V136.301Z",
    fill: "#005FAD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.21 122.551H68.46V136.301H82.21V122.551Z",
    fill: "#005FAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.96 136.301H82.21V150.051H95.96V136.301Z",
    fill: "#005FAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.72 122.551H95.9697V136.301H109.72V122.551Z",
    fill: "#005FAD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.479 136.301H109.729V150.051H123.479V136.301Z",
    fill: "#005FAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFilePng);
export default __webpack_public_path__ + "static/media/icn_file_png.426961fbdacf5e0470e86b2e6778117b.svg";
export { ForwardRef as ReactComponent };